import { noneHighlighted } from './node'

export const highlighted = (link: object): boolean => {
  if (noneHighlighted()) return
  return globalThis._CONFIGURATION_.highlighted.filter(id => id === link.source.id || id === link.target.id).length > 1
}

export const linkCores = (nodes: array, links: array): array => {
  const coreNodes = nodes.filter(d => d.core === true)
  const coreLinks = links
  coreNodes.forEach((node: object, index: number) => {
    const nextNode = coreNodes[index + 1] === undefined ? coreNodes[0] : coreNodes[index + 1]
    if (node.render === false || nextNode.render === false) return
    const coreDistance = [node.coreDistance, nextNode.coreDistance].sort((a, b) => b - a)[0]
    const link = {
      id: `core-link-${index}`,
      source: node.id,
      target: nextNode.id,
      core: true,
      coreDistance,
      visible: false
    }
    coreLinks.push(link)
  })
  return coreLinks
}
